import formEcossistema from '@/components/Ecossistemas/formEcossistema.vue';

export default {
    name: "CriarEcossistema",
    components: { formEcossistema }
    //
}